import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { RepairResultCard } from './RepairResultCard';
import { Repair } from '../../../data/Repair';

type RepairResultCardListProps = {
    repairList: Repair[],
    onClick: (repair: Repair) => void,
};

RepairResultCardList.defaultProps = {

};

const useStyle = makeStyles((theme: Theme) => createStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
    },
}));

function RepairResultCardList(props: RepairResultCardListProps): React.ReactElement {
    const {
        repairList,
        onClick,
    } = props;
    const classes = useStyle();

    return (
        <div className={classes.root}>
            {repairList.map((repair) => (
                <RepairResultCard onClick={() => onClick(repair)} repair={repair} />
            ))}
        </div>
    );
}

export { RepairResultCardList };
